/**
 * Formats a postal code for the given country (NL: `1234 AB`, BE: 4 digits, DE: 5 digits).
 * Other/unknown countries are returned unchanged. Pure — lifted from the legacy PostalCodeField.
 */
export function formatPostalCode(value = '', country?: string): string {
    if (!value) {
        return ''
    }
    switch (country) {
        case 'NL':
            return value
                .replace(/^[^1-9]*([1-9]?)[^\d]*(\d?)[^\d]*(\d?)[^\d]*(\d?)[^a-z]*([a-z]?)[^a-z]*([a-z]?).*$/gi, '$1$2$3$4 $5$6')
                .toUpperCase()
                .trim()
        case 'BE':
            return value.replace(/\D/g, '').replace(/^(\d{4}).*/g, '$1')
        case 'DE':
            return value.replace(/\D/g, '').replace(/^(\d{5}).*/g, '$1')
    }
    return value
}
